var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _g5, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 316,
    viewBox: "0 0 430 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.33 80.4445L156.671 91.7788L110.271 64.8597L130.638 53.5254L176.33 80.4445Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.33 140.305L156.671 151.639L110.271 124.72L130.638 113.386L176.33 140.305Z",
    stroke: "#231F20",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.218 140.305L156.56 151.639L110.16 124.72L130.527 113.386L176.218 140.305Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.674 91.7793V151.639",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.817 53.5254V113.385L110.293 124.7V64.8401",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.33 80.248V140.108",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.199 102.564L117.541 113.898L71.1406 86.9789L91.507 75.6445L137.199 102.564Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 162.423L117.541 173.757L71.1406 146.838L91.507 135.504L137.199 162.423Z",
    stroke: "#231F20",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.087 162.423L117.429 173.757L71.0293 146.838L91.3957 135.504L137.087 162.423Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.543 113.898V173.758",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.686 75.6445V135.504L71.1621 146.819V86.9592",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 102.367V162.227",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M301.667 110.375L282.009 121.709L235.609 94.7904L255.976 83.4561L301.667 110.375Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M301.667 170.235L282.009 181.569L235.609 154.65L255.976 143.315L301.667 170.235Z",
    stroke: "#231F20",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M301.556 170.235L281.898 181.569L235.498 154.65L255.864 143.315L301.556 170.235Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M282.01 121.709V181.569",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M256.153 83.4561V143.316L235.629 154.63V94.7707",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.668 110.178V170.037",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.583 144.148L342.925 155.482L296.525 128.563L316.892 117.229L362.583 144.148Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.583 204.007L342.925 215.341L296.525 188.422L316.892 177.088L362.583 204.007Z",
    stroke: "#231F20",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.472 204.007L342.814 215.341L296.414 188.422L316.78 177.088L362.472 204.007Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.928 155.481V215.341",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.069 117.229V177.088L296.545 188.403V128.543",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.584 143.951V203.811",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M192.314 69.8908L211.972 81.2251L258.372 54.306L238.006 42.9717L192.314 69.8908Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M192.314 129.75L211.972 141.084L258.372 114.165L238.006 102.831L192.314 129.75Z",
    stroke: "#231F20",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M192.426 129.75L212.084 141.084L258.484 114.165L238.117 102.831L192.426 129.75Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M211.973 81.2246V141.084",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 42.9717V102.831L258.352 114.146V54.2864",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M192.314 69.6934V129.553",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.053 42.9191L168.711 54.2534L215.111 27.3344L194.744 16L149.053 42.9191Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.053 102.778L168.711 114.113L215.111 87.1937L194.744 75.8593L149.053 102.778Z",
    stroke: "#231F20",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.164 102.778L168.822 114.113L215.222 87.1937L194.856 75.8594L149.164 102.778Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.711 54.2539V114.113",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.566 15.9999V75.8594L215.09 87.1741V27.3146",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.053 42.7227V102.582",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.268 226.782L214.926 238.117L261.326 211.198L240.959 199.863L195.268 226.782Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.268 286.642L214.926 297.976L261.326 271.057L240.959 259.723L195.268 286.642Z",
    stroke: "#231F20",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.379 286.642L215.037 297.976L261.437 271.057L241.071 259.723L195.379 286.642Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.926 238.116V297.976",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.781 199.863V259.723L261.305 271.037V211.178",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.268 226.586V286.446",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M156.674 199.935L176.332 211.269L222.732 184.35L202.365 173.016L156.674 199.935Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M156.674 259.795L176.332 271.129L222.732 244.21L202.365 232.876L156.674 259.795Z",
    stroke: "#231F20",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M156.785 259.795L176.443 271.129L222.843 244.21L202.477 232.876L156.785 259.795Z",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M176.33 211.27V271.129",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M202.188 173.016V232.875L222.711 244.19V184.33",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M156.674 199.738V259.598",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.7207 77.8809L374.072 246.539",
    stroke: "white",
    strokeWidth: 7.38724,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.863 226.633L273.389 262.654L125.93 177.105L190.654 141.084L335.863 226.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 213.484L130.725 177.464",
    stroke: "white",
    strokeWidth: 7.38724,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3167 199.538L66 213.028L79.9214 217.668",
    stroke: "white",
    strokeWidth: 7.38724,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.287 251.264L376.999 247.717L373.495 233.467",
    stroke: "white",
    strokeWidth: 7.38724,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9954 70.9111L84.0781 76.7206L89.9355 90.1753",
    stroke: "white",
    strokeWidth: 7.38724,
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M300.932 190.979L216.525 240.586",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M245.891 160.544L219.355 176.139",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M273.163 206.472L165.549 146.298",
    stroke: "white",
    strokeWidth: 0.923406,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.395b039fdfc42d7d53c5cf79a49c094c.svg";
export { ForwardRef as ReactComponent };